import classNames from 'classnames';
import { ReactComponent as HERO } from '../assets/hero.svg';
import { useState } from 'react';
import { ChevronDownIcon, Facebook, Linkedin, Twitter } from 'lucide-react';
import { motion } from 'framer-motion';
import Toast from './toast';
import useMediaQuery from '@mui/material/useMediaQuery';
export default function Contact() {
  // Select dropdown state
  const [isOpen, setIsOpen] = useState(false);
  // Toast message state
  const [message, setMessage] = useState('');
  const [showToast, setShowToast] = useState(false);

  const showToastMessage = () => {
    setShowToast(true);
  };

  const hideToastMessage = () => {
    setShowToast(false);
  };


  // Form data state
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    phoneNumber: '',
    email: '',
    subject: 'Select a Subject',
    message: ''
  });
  const verify_Form = (formData) => {
    if(formData.firstName === '' || formData.lastName === '' || formData.company === '' || formData.phoneNumber === '' || formData.email === '' || formData.subject === '' || formData.message === ''){
      return false;
    }
    return true;
  }

  //const endpoint = 'http://localhost:5000/contact'; // This is the endpoint where the form data will be sent to
  const API_URL = process.env.API_URL;
  //const endpoint = API_URL+"/contact";
  // Handle form input changes
  //const endpoint = 'http://localhost:32104/contact';
  const endpoint = process.env.API_URL+"/contact" || 'http://srv440171.hstgr.cloud:3002/contact';
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!verify_Form(formData)){
      setMessage('Please fill in all the fields.');
      showToastMessage();
      return;
    }
    if(formData.subject === 'Select a Subject'){
      setMessage('Please select a subject.');
      showToastMessage();
      return;
    }
    if(!emailPattern.test(formData.email)){
      setMessage('Please enter a valid email address.');
      showToastMessage(); 
      return;
    }

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setMessage('Your message has been sent successfully!');
        showToastMessage();
        setFormData({
          firstName: '',
          lastName: '',
          company: '',
          phoneNumber: '',
          email: '',
          subject: 'Select a Subject',
          message: ''
        });
      } else {
        setMessage('An error occurred. Please try again.');
        showToastMessage();
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
      showToastMessage();
    }
  };

  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    isMobile ?
    <div id='contact' className='w-full h-fit flex flex-col items-center px-4 gap-12 relative'>
      <HERO preserveAspectRatio='xMidYMid slice' className='w-full top-[10vh] h-[90vh] absolute z-0'></HERO>
      <h4 className='font-bold  px-4 s:text-[2rem] xs:text-[1.75rem] text-stone-700 text-center '>
        Ready to start your next project with us?
      </h4>
      <div className='flex relative z-10 p-5 flex-col w-full   bg-white gap-8 shadow-card hover:shadow-card2 rounded-[16px]'>
        <div>
        <h5 className='text-stone-700 bg-white font-medium text-[1.5rem]'>Get In Touch!</h5>
        <h6 className='text-stone-500 bg-white font-normal text-[1.25rem]'>You can reach us anytime</h6>
        </div>
        <form onSubmit={handleSubmit} className='flex flex-col gap-4 ' >
              <input
                name='firstName'
                value={formData.firstName}
                onChange={handleChange}
                placeholder='First Name'
                className='px-2 border-2 rounded-[8px] border-gray-200 focus:border-orange-100  outline-none py-2 w-full text-[1rem] text-stone-600 placeholder:text-gray-400'

              />
              <input
                name='lastName'
                value={formData.lastName}
                onChange={handleChange}
                className='px-2 border-2 rounded-[8px] border-gray-200 focus:border-orange-100  outline-none py-2 w-full text-[1rem] text-stone-600 placeholder:text-gray-400'
                placeholder='Last Name'
              />
            <input
              name='company'
              value={formData.company}
              onChange={handleChange}
              placeholder='Company'
              className='px-2 border-2 rounded-[8px] border-gray-200 focus:border-orange-100 outline-none py-2 w-full text-[1rem] text-stone-600 placeholder:text-gray-400'
            />
              <input
                name='phoneNumber'
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder='Phone Number'
                className='px-2 border-2 rounded-[8px] border-gray-200 focus:border-orange-100 outline-none py-2 w-full text-[1rem] text-stone-600 placeholder:text-gray-400'
              />
              <input
                name='email'
                value={formData.email}
                onChange={handleChange}
                placeholder='Your Email'
                className='px-2 border-2 rounded-[8px] border-gray-200 focus:border-orange-100 outline-none py-2 w-full text-[1rem] text-stone-600 placeholder:text-gray-400'
              />
            <div className='relative w-full group'>
            <select
              onClick={() => setIsOpen(!isOpen)}
              name='subject'
              value={formData.subject}
              onChange={handleChange}
              className={classNames('px-2 cursor-pointer border-2 rounded-[8px] border-gray-200 focus:border-orange-100 appearance-none outline-none py-2 w-full text-[1rem]',{ 'text-gray-400': formData.subject === 'Select a Subject' , 'text-stone-600': formData.subject !== 'Select a Subject' })}
              >
              <option value="Select a Subject" disabled selected>
                Select a Subject
              </option>
              <option  value='Information About the Product' >Information About the Product</option>
              <option value='Get a Quote'>Get a Quote</option>
              <option value='Get a Demo'>Get a Demo</option>
              <option value='Training Informations'>Training Informations</option>
              <option value='Contribution Ideas'>Contribution Ideas</option>
              <option value='Other'>Other</option>
            </select>
            <ChevronDownIcon className={classNames('absolute transition-all duration-300 right-2 top-0 bottom-0 m-auto h-4 w-4 text-gray-400 group-hover:text-stone-600' , {"rotate-180":isOpen})} ></ChevronDownIcon>
            </div>
            <textarea
              name='message'
              value={formData.message}
              onChange={handleChange}
              rows={4}
              placeholder='How can we help you?'
              className='px-2 border-2 rounded-[4px] border-gray-200 focus:border-orange-100 outline-none py-2 w-full text-[1rem] text-stone-600 placeholder:text-gray-400'
            ></textarea>
            <button className={classNames('w-full text-[1rem] font-medium text-white rounded-[8px] py-2 transition-all duration-300 ease-in-out', {"bg-orange-300" : !verify_Form(formData) , "bg-orange-500": verify_Form(formData)} )} type='submit'>
              SUBMIT
            </button>
        </form>
        </div>
      <div className='flex flex-col px-4 gap-8 '>
      <div>
      <h6 className='text-stone-700  font-medium text-[1.5rem]'>Contact Us</h6>
      <p className='text-[1.125rem] font-normal text-stone-500'>Give us a call or send us an email and we will get back to you as soon as possible!</p>
      </div>

      <div className='flex justify-between'>
                  <a href='mailto:contact@itops-bridge.com' className='text-stone-900 underline hover:text-orange-600 font-medium cursor-pointer transition-colors duration-300 ease-in'>contact@itops-bridge.com</a>
                  <div className='flex gap-4'>
                    <Facebook size={24} className='text-stone-700 hover:text-orange-600 transition-colors duration-300 ease-in cursor-pointer ' strokeWidth={2} />
                    <Twitter size={24} className='text-stone-700 hover:text-orange-600 transition-colors duration-300 ease-in cursor-pointer ' strokeWidth={2} />
                    <Linkedin size={24} className='text-stone-700 hover:text-orange-600 transition-colors duration-300 ease-in cursor-pointer ' strokeWidth={2} />
                  </div>
      </div>

      <iframe  title='Adress'
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12767.291950802417!2d10.3110891!3d36.8706556!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12e2b4e74fa96d63%3A0xca31962b759778fd!2sDomi!5e0!3m2!1sar!2stn!4v1740495499789!5m2!1sar!2stn"
            width="100%" height="100%"
              allowfullscreen="" 
              loading="eager" 
              className='rounded-[8px] h-[256px] w-full'
              referrerpolicy="no-referrer-when-downgrade"
              
              >
       </iframe>
       <p className='py-4 self-center text-stone-500 xs:text-[0.875rem] s:text-[1rem]'>Copyright © 2025 - ITOps Bridge</p>
      </div>
    </div>
    :
    <div id='contact' className='w-full gap-[5.925vh]  z-10 h-fit flex flex-col relative items-center'>
      <HERO preserveAspectRatio='none' className='w-full top-[10vh] h-[90vh] absolute z-0'></HERO>
      <motion.h4 viewport={{ once: true }}  initial={{opacity:0,y:-50}} whileInView={{opacity:1,y:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className='font-bold mt-[15.925vh] z-50 text-[2.1875vw] text-stone-700'>Ready to start your next project with us?</motion.h4>
      <div className='flex gap-[8.333vw] px-[7.407vh]'>
        {/* informations */}
        <div  className='z-10 pt-[11.85vh] flex flex-col gap-[4.44vh]'>
          <motion.div viewport={{ once: true }}  initial={{opacity:0,x:-50}} whileInView={{opacity:1,x:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className='flex flex-col gap-[1.481vh]'>
            <h6 className='text-stone-700  font-medium text-[1.875vw]'>Contact Us</h6>
            <p className='text-[1.145vw] font-medium text-stone-500'>Give us a call or send us an email and we will get back to you as soon as possible!</p>
          </motion.div>
          <div className='flex flex-col h-full gap-[5.92vh]'>
            <motion.div viewport={{ once: true }}  initial={{opacity:0,x:-50}} whileInView={{opacity:1,x:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} className='flex justify-between'>
                  <a href='mailto:contact@itops-bridge.com' className='text-stone-900 underline hover:text-orange-600 font-medium cursor-pointer transition-colors duration-300 ease-in'>contact@itops-bridge.com</a>
                  <div className='flex gap-[1.666vw]'>
                    <Facebook size={24} className='text-stone-700 hover:text-orange-600 transition-colors duration-300 ease-in cursor-pointer ' strokeWidth={2} />
                    <Twitter size={24} className='text-stone-700 hover:text-orange-600 transition-colors duration-300 ease-in cursor-pointer ' strokeWidth={2} />
                    <Linkedin size={24} className='text-stone-700 hover:text-orange-600 transition-colors duration-300 ease-in cursor-pointer ' strokeWidth={2} />
                  </div>
            </motion.div>

            {/*maps iframe*/}
            <motion.iframe viewport={{ once: true }}  initial={{opacity:0,y:50}} whileInView={{opacity:1,y:0}} transition={{type:"spring",duration:1 , delay:0.5 ,ease : 'easeOut'}} title='Adress'
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12767.291950802417!2d10.3110891!3d36.8706556!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12e2b4e74fa96d63%3A0xca31962b759778fd!2sDomi!5e0!3m2!1sar!2stn!4v1740495499789!5m2!1sar!2stn"
            width="100%" height="100%"
              allowfullscreen="" 
              loading="eager" 
              className='rounded-[1.04vw] h-full w-full'
              referrerpolicy="no-referrer-when-downgrade"
              
              >
              </motion.iframe>
          </div>

        </div>

        {/* contact Form */}
        <motion.div viewport={{ once: true }}  initial={{opacity:0,x:50}} whileInView={{opacity:1,x:0}} transition={{type:"spring",duration:1 , delay:1 ,ease : 'easeOut'}} className='p-[2.925vh] flex flex-col gap-[2.962vh] bg-white z-30 rounded-[1.04vw] shadow-card font-medium text-[1.875vw]'>
          <div className='flex flex-col'>
            <h5 className='text-stone-700 bg-white font-medium text-[1.875vw]'>Get In Touch!</h5>
            <h6 className='text-stone-500 bg-white font-normal text-[1.4583vw]'>You can reach us anytime</h6>
          </div>

          <form onSubmit={handleSubmit} className='flex flex-col gap-[2.222vh]'>
            <div className='flex gap-[1.666vw]'>
              <input
                name='firstName'
                value={formData.firstName}
                onChange={handleChange}
                className='px-[1.25vw] border-2 rounded-[0.8333vw] border-gray-200 focus:border-orange-100 outline-none py-[1.111vh] w-full text-[1.145vw] text-stone-600 placeholder:text-gray-400'
                placeholder='First Name'
              />
              <input
                name='lastName'
                value={formData.lastName}
                onChange={handleChange}
                className='px-[1.25vw] border-2 rounded-[0.8333vw] border-gray-200 focus:border-orange-100 outline-none py-[1.111vh] w-full text-[1.145vw] text-stone-600 placeholder:text-gray-400'
                placeholder='Last Name'
              />
            </div>
            <input
              name='company'
              value={formData.company}
              onChange={handleChange}
              className='px-[1.25vw] border-2 rounded-[0.8333vw] border-gray-200 focus:border-orange-100 outline-none py-[1.111vh] w-full text-[1.145vw] text-stone-600 placeholder:text-gray-400'
              placeholder='Company'
            />
            <div className='flex gap-[1.666vw]'>
              <input
                name='phoneNumber'
                value={formData.phoneNumber}
                onChange={handleChange}
                className='px-[1.25vw] border-2 rounded-[0.8333vw] border-gray-200 focus:border-orange-100 outline-none py-[1.111vh] w-full text-[1.145vw] text-stone-600 placeholder:text-gray-400'
                placeholder='Phone Number'
              />
              <input
                name='email'
                value={formData.email}
                onChange={handleChange}
                className='px-[1.25vw] border-2 rounded-[0.8333vw] border-gray-200 focus:border-orange-100 outline-none py-[1.111vh] w-full text-[1.145vw] text-stone-600 placeholder:text-gray-400'
                placeholder='Your Email'
              />
            </div>
            <div className='relative w-full group'>
            <select
              onClick={() => setIsOpen(!isOpen)}
              name='subject'
              value={formData.subject}
              onChange={handleChange}
              className={classNames('px-[1.25vw] cursor-pointer border-2 rounded-[0.8333vw] border-gray-200 focus:border-orange-100 appearance-none outline-none py-[1.111vh] w-full text-[1.145vw]',{ 'text-gray-400': formData.subject === 'Select a Subject' , 'text-stone-600': formData.subject !== 'Select a Subject' })}
              >
              <option value="Select a Subject" disabled selected>
                Select a Subject
              </option>
              <option  value='Information About the Product' >Information About the Product</option>
              <option value='Get a Quote'>Get a Quote</option>
              <option value='Get a Demo'>Get a Demo</option>
              <option value='Training Informations'>Training Informations</option>
              <option value='Contribution Ideas'>Contribution Ideas</option>
              <option value='Other'>Other</option>
            </select>
            <ChevronDownIcon className={classNames('absolute transition-all duration-300 right-[1.25vw] top-0 bottom-0 m-auto h-[1.666vw] w-[1.666vw] text-gray-400 group-hover:text-stone-600' , {"rotate-180":isOpen})} ></ChevronDownIcon>
            </div>
            <textarea
              name='message'
              value={formData.message}
              onChange={handleChange}
              className='px-[1.25vw] border-2 rounded-[0.8333vw] border-gray-200 focus:border-orange-100 outline-none py-[1.111vh] w-full text-[1.145vw]  text-stone-600 placeholder:text-gray-400 resize-none'
              rows={3}
              placeholder='How can we help you?'
            ></textarea>
            <button className={classNames('w-full text-[1.145vw] text-white  rounded-[0.8333vw] py-[0.74vh] transition-all duration-300 ease-in-out', {"bg-orange-300" : !verify_Form(formData) , "bg-orange-500": verify_Form(formData)} )} type='submit'>
              SUBMIT
            </button>
          </form>
        </motion.div>
      </div>
      <p className='py-[2vh] text-stone-500 text-[0.729vw]'>Copyright © 2025 - ITOps Bridge</p>
      <Toast message={message} show={showToast}  onClose={hideToastMessage}></Toast>
    </div>
    
  );
}
